
import { getNewLateRouteSequence, getLateRoutesSheetData, postNewLateRouteForm, putLateRoutesSheetData, getSchoolYear } from '../api.js'

import partitions from '../partitions.js'
import vendors from '../vendors.js'
import districts from '../districts.js'

import notifications from '../notifications.js'
import pageApiData from '../utils/pageApiData.js'

const [ _getSchoolYearFromServer, _getSchoolYear, _getSchoolYearSync ] = pageApiData.createFunctions(getSchoolYear, 'Unable to get school year data from server.', function (code) { return elem => elem.code === code })
const [ _getNewLateRouteSequenceFromServer, _getNewLateRouteSequence, _getNewLateRouteSequenceSync ] = pageApiData.createFunctions(getNewLateRouteSequence, 'Unable to load next field data from server.')
const [ _getLateRoutesSheetDataFromServer, _getLateRoutesSheetData, _getLateRoutesSheetDataSync ] = pageApiData.createFunctions(getLateRoutesSheetData, 'Unable to get "late route sheet data" from server.')

function _getLateRouteFormSchoolYearOptionsFromCapability(user) {
  if (user === undefined) {
    return Promise.resolve([])
  }

  let capViewLateRouteForm = user.getCapability('view_late_route_form')
  let schoolYearOptions = capViewLateRouteForm.getSchoolYearOptions()

  let promiseSchoolYear = _getSchoolYearFromServer()
    .then(() => {
      return schoolYearOptions.map(function (option) {
        let schoolYear = _getSchoolYearSync(option.schoolYear)
        return {
          label: schoolYear.display,
          value: option.schoolYear,
        }
      })
    })

  return promiseSchoolYear
}

function _getLateRouteFormVendorOptionsFromCapability(user) {
  if (user === undefined) {
    return Promise.resolve([])
  }

  let capViewLateRouteForm = user.getCapability('view_late_route_form')
  let vendorOptions = capViewLateRouteForm.getVendorOptions()

  if (vendorOptions.length === 0) {
    let userConfigVendorId = user.getConfig('vendor_id')
    if (userConfigVendorId) {
      vendorOptions = [{ vendor: userConfigVendorId }]
    }
  }

  let promiseVendor = vendors.getVendorFromServer()
  let promiseParition = partitions.getPartitionFromServer()

  let promiseFinalVendorOptions = Promise.all([promiseVendor, promiseParition])
    .then(() => {
      return vendorOptions
        .filter(option => vendors.getVendorSync(option.vendor) !== undefined)
        .map(function (option) {
          let vendor = vendors.getVendorSync(option.vendor)
          return {
            label: `${vendor.name} -- ${partitions.getPartitionNameSync(vendor.partition)}`,
            value: option.vendor,
          }
        })
    })

  return promiseFinalVendorOptions
}

function _canSubmitForm(user) {
  if (user === undefined) {
    return false
  }

  return user.can('submit_late_route_form')
}

function _postNewLateRouteForm(content) {
  let promise = postNewLateRouteForm(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _putLateRoutesSheetData(content) {
  let promise = putLateRoutesSheetData(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, spreadsheet information submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _getVendor(vendorId) {
  return vendors.getVendorFromServer()
    .then(() => {
      return vendors.getVendor(vendorId)
    })
}

function _getPartition(partitionId) {
  return partitions.getPartitionFromServer()
    .then(() => {
      return partitions.getPartition(partitionId)
    })
}

function _getDistrict(districtCode) {
  return districts.getDistrictFromServer()
    .then(() => {
      return districts.getDistrict(districtCode)
    })
}

export default {
  getNewLateRouteSequenceFromServer: _getNewLateRouteSequenceFromServer,
  getNewLateRouteSequence: _getNewLateRouteSequence,
  getNewLateRouteSequenceSync: _getNewLateRouteSequenceSync,
  getLateRoutesSheetDataFromServer: _getLateRoutesSheetDataFromServer,
  getLateRoutesSheetData: _getLateRoutesSheetData,
  getLateRoutesSheetDataSync: _getLateRoutesSheetDataSync,
  getSchoolYearFromServer: _getSchoolYearFromServer,
  getSchoolYear: _getSchoolYear,
  getSchoolYearSync: _getSchoolYearSync,

  getVendor: _getVendor,
  getPartition: _getPartition,
  getDistrict: _getDistrict,

  postNewLateRouteForm: _postNewLateRouteForm,
  putLateRoutesSheetData: _putLateRoutesSheetData,
  getLateRouteFormSchoolYearOptionsFromCapability: _getLateRouteFormSchoolYearOptionsFromCapability,
  getLateRouteFormVendorOptionsFromCapability: _getLateRouteFormVendorOptionsFromCapability,
  canSubmitForm: _canSubmitForm,
}
